import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9c7492d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "details-subscribe-bar-wrap"
}
const _hoisted_2 = { class: "cm-ui-mr20 cm-ui-ml10" }
const _hoisted_3 = { style: {"color":"var(--cm-color-text-regular)","cursor":"not-allowed","margin-left":"5px"} }
const _hoisted_4 = {
  key: 1,
  class: "details-subscribe-bar-wrap"
}
const _hoisted_5 = { class: "cm-ui-mr20 cm-ui-ml10" }
const _hoisted_6 = {
  key: 2,
  class: "details-subscribe-bar-wrap"
}
const _hoisted_7 = { class: "cm-ui-mr20 cm-ui-ml10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_ctx.authStatus === _ctx.TerminalAuthStatus.unauthorized)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_CmSvgIcon, {
          name: "views/dashboard/_components/subscribe-bar/_images/warning-circle",
          monochrome: "",
          size: 18
        }),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('serviceSubscribe.detailsBarUnauthorizedTip', { name: _ctx.$t(_ctx.PermissionFeMap[_ctx.permissionKey]?.name) })), 1),
        (_ctx.isBasicServiceInJP)
          ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 0,
              effect: "light",
              placement: "top",
              content: _ctx.$t('mySubscribe.freeBasicNoAdjustTip')
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('serviceSubscribe.detailsBarConfigureNow')), 1)
              ]),
              _: 1
            }, 8, ["content"]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              size: "mini",
              round: "",
              type: "primary",
              onClick: _ctx.handleAuth
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('serviceSubscribe.detailsBarConfigureNow')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
      ]))
    : (_ctx.isShowExperience)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/_components/subscribe-bar/_images/warning-circle",
            monochrome: "",
            size: 18
          }),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('serviceSubscribe.pageBarTrialTip', { days: _ctx.countdownDay(_ctx.permissionInfo.expire_time) })), 1),
          _createVNode(_component_el_button, {
            size: "mini",
            round: "",
            type: "primary",
            onClick: _ctx.toSubscribe
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('serviceSubscribe.pageBarTrialAction')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : (_ctx.isShowExpire)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_CmSvgIcon, {
              name: "views/dashboard/_components/subscribe-bar/_images/warning-circle",
              monochrome: "",
              size: 18
            }),
            _createElementVNode("div", _hoisted_7, [
              (!_ctx.normalPermissionKey && _ctx.linuxPermissionKey)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('subscribeDetails.areaTypeLinux')), 1)
                  ], 64))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('serviceSubscribe.detailsBarExpiredNamePart', { name: _ctx.$t(_ctx.PermissionFeMap[_ctx.permissionKey]?.name) })), 1)
            ]),
            _createVNode(_component_el_button, {
              size: "mini",
              round: "",
              type: "primary",
              onClick: _ctx.toSubscribe
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('serviceSubscribe.pageBarExpireAction')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
}